import axios from 'axios'
import AuiToast from '../../assets/js/aui-toast'

/**
 *  获取用户的所有项目
 * @param option.queryParam 模糊查询条件
 * @param option.pageNo 页数
 * @param option.projectProductType 项目产品类型；-1-其他；0-恒流控制器；1-人体感应；2-市电互补；3-开关控制器
 * @returns {Promise<void>}
 */
const getAllProjects = async (option) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  let {queryParam, pageNo, projectProductType} = option
  let size = 30
  return axios.get(`/api/v2/projects/list-mine-pagi?queryParam=${queryParam}&pageNo=${pageNo}&pageSize=${size}&projectProductType=${projectProductType}`, {})
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 *  设置是否关注项目
 ** @param {*Number} option.projectId 项目id
 * @param {String} option.tag 标签（“,”隔开）
 * @param {Number} option.follow 是否关注；1-关注；0-不关注；
 * @returns {Promise<void>}
 */
const setProjectFollow = async (option) => {
  let {tag, follow} = option
  AuiToast.loading({
    title: follow === 1 ? '关注中...' : '取消关注中...',
    duration: 2000
  }, function (ret) {})
  return axios.post(`/api/v2/projects/set-tag-or-follow/${option.projectId}`, {tag, follow})
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 删除项目
 * @param {*String} projectId
 */
const deleteProject = async (projectId, projectProductType) => {
  let url = `/api/v2/projects/${projectId}`
  if (Number(projectProductType) === 16) {
    url = `/api/repower/v2/projects/${projectId}`
  }
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.delete(url, {})
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 新增项目
 * @param {*String} options.name 项目名称
 * @param {*String} options.adCode 地址码
 * @param {*boolean} options.autoLocation 是否自动开启扫描定位
 * @param {String} options.location 位置
 * @param {String} options.remark 备注
 */
const createProject = async (option) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.post(`/api/v2/projects`, option)
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 获取项目概览信息
 * @param {*String} projectId 项目id
 */
const getProjectstatistInfor = async (projectId) => {
  return axios.get(`/api/v2/project-overviews/${projectId}`, {})
    .then(res => {
      return res
    })
}

/**
 * 获取项目信息
 * @param {*String} projectId 项目id
 */
const getProjectInfor = async (projectId) => {
  return axios.get(`/api/v2/projects/${projectId}`, {})
    .then(res => {
      return res
    })
}

/**
 * 修改项目
 * @param {*String} options.projectId 项目id
 * @param {*String} options.name 项目名称
 * @param {String} options.location 位置
 * @param {String} options.remark 备注
 */
const updateProjectInfor = async (options) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.put(`/api/v2/projects/${options.projectId}`, options)
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 设置项目关注或者标签
 * @param {*Number} options.projectId 项目id
 * @param {String} options.tag 标签（“,”隔开）
 * @param {Number} options.follow 是否关注；1-关注；0-不关注；
 */
const setTagOrFollow = async (options) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.post(`/api/v2/projects/set-tag-or-follow/${options.projectId}`, options)
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 获取当前用户能查询的产品类别
 */
const getProductTpyes = async () => {
  return axios.get(`/api/v2/projects/list-my-project-product-type`, {})
    .then(res => {
      return res
    })
}
/**
 *  获取项目历史总充放电量
 * @param projectId 项目id
 * @returns {Promise<void>}
 */
const getSolarStatisticsProjectHis = async (projectId) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.get(`/api/v2/solar-mote-status-hiss/get-solar-statistics-project-his?projectId=${projectId}`, {})
    .then(res => {
      AuiToast.hide()
      return res
    })
}
// 获取项目下的项目参数列表
const getProjectParam = async (projectId) => {
  let data = await axios.get(`/api/v1/sys-params/project?projectId=${projectId}`)
  return data
}
// 保存/更新项目参数
const setProjectParam = async (projectId, paramKey, options) => {
  let data = await axios.put(`/api/v1/sys-params/project/${projectId}/${paramKey}`, options)
  return data
}
// 获取当前用户的过期提醒项目列表
const getProjectsExpire = async () => {
  let data = await axios.get(`/api/v2/projects/expire`)
  return data
}

const project = {
  getAllProjects,
  setProjectFollow,
  deleteProject,
  createProject,
  getProjectstatistInfor,
  getProjectInfor,
  updateProjectInfor,
  setTagOrFollow,
  getProductTpyes,
  getSolarStatisticsProjectHis,
  getProjectParam,
  setProjectParam,
  getProjectsExpire
}
export default project
